/* eslint-disable capitalized-comments */
import React from 'react';
import TableCell from '@mui/material/TableCell';
import { RemoteDataGrid } from '@cloudhub-ux/core/datagrid';

import Block from '@cloudhub-ux/core/Block';
import Alert from '@cloudhub-ux/core/Alert';
import useAdminAxios from 'admin/context/useAdminAxios';
import Check from '@mui/icons-material/Check';
import { colors } from 'theme';
import EntrycategoryForm from './forms/EntrycategoryForm';

// const dateFormat = 'DD-MMM-YYYY hh:mm a';

const Entrycategory = () => {
  const { getData, adminaxiosinstance } = useAdminAxios();
  const gridRef = React.useRef();
  const [error, setError] = React.useState('');
  const [editingRow, setEditingRow] = React.useState(null);

  const deleteRows = async (deletingRows) => {
    const ids = deletingRows.map((item) => item.id);
    getData({
      url: '/website/entrycategory/delete',
      params: { entrycategorys: ids },
    });
    gridRef.current.onDeleteSuccess(deletingRows);
  };

  const cellComponent = ({ row, column }) => {
    // Row, column, style
    if (column.name === 'discount') {
      return <TableCell />;
    }
    if (column.name === 'AllowEntry') {
      return (
        <TableCell>
          {row[column.name] === true ? (
            <Check style={{ fontWeight: 'bold', color: colors.success }} />
          ) : (
            ''
          )}
        </TableCell>
      );
    }
    return (
      <TableCell>
        {`${typeof row[column.name] === 'undefined' ? '' : row[column.name]}`}
      </TableCell>
    );
  };

  const cols = [
    { name: 'CategoryCode', title: 'Category Code' },
    { name: 'CategoryName', title: 'Category Name' },
    { name: 'AllowEntry', title: 'Entries Allowed' },
  ];

  const columnWidths = [
    { columnName: 'CategoryCode', width: 120 },
    { columnName: 'AllowEntry', width: 120 },
    { columnName: 'CategoryName', width: 150 },
  ];

  return (
    <Block>
      <Block flex={false}>
        {Boolean(error) && (
          <Alert error message={error} onClose={() => setError('')} />
        )}
      </Block>
      <RemoteDataGrid
        title="Entry Categories"
        url="/website/entrycategory/getall"
        axiosinstance={adminaxiosinstance}
        columns={cols}
        columnWidths={columnWidths}
        allowColumnResizing={false}
        cellComponent={cellComponent}
        onAdd={() => setEditingRow({})}
        onDeleteRows={deleteRows}
        onEdit={(row) => setEditingRow(row)}
        ref={gridRef}
        pagingComponent={null}
      />
      {editingRow && (
        <EntrycategoryForm
          editingRow={editingRow}
          onCancelEdit={() => setEditingRow(null)}
          onSave={(row) => gridRef.current.onSave(row)}
        />
      )}
    </Block>
  );
};

export default Entrycategory;
